import {useQuery} from '@tanstack/react-query';
import {useEffect, useState} from 'react';
import {showSnackbar} from '../../../api/snackbarSlice';
import {useDispatch} from 'react-redux';
import {apiClient} from '../../../utils/axios';
import {AxiosError} from 'axios';

export const fetchSalesInvoices = async (query) => {
    const { data } = await apiClient.get(`/sales-invoices`, { params: query.queryKey[1] });
    return data;
};

export const fetchPurchaseInvoices = async (query) => {
    const { data } = await apiClient.get(`/purchase-invoices`, { params: query.queryKey[1] });
    return data;
};


export const useGetInvoicesHandler = ({searchQuery, isPurchase=false}) => {
    const dispatch = useDispatch();
    const [invoices, setInvoices] = useState([]);
    const [totalDocuments, setTotalDocuments] = useState(0);

    const {
        data: fetchedData,
        isLoading,
        isError,
        error,
    } = useQuery({
        queryKey: [isPurchase ? 'purchase-invoices' : 'sales-invoices', { ...searchQuery }],
        queryFn: isPurchase ? fetchPurchaseInvoices : fetchSalesInvoices,
        refetchOnWindowFocus: true,
        refetchOnReconnect: true,
        refetchOnMount: 'always',
        cacheTime: 0,
        retry: 3,
    });

    useEffect(() => {
        if (fetchedData) {
            setInvoices(fetchedData.content);
            setTotalDocuments(fetchedData.total_elements);
        }
    }, [fetchedData]);

    useEffect(() => {
        if (isError) {
            if (error instanceof AxiosError) {
                if (error.status) {
                    dispatch(showSnackbar({message: error.response.data.message, severity: 'error'}));
                } else {
                    dispatch(showSnackbar({message: error.message, severity: 'error'}));
                }
            } else {
                dispatch(showSnackbar({message: JSON.stringify(error), severity: 'error'}));
            }
        }
    }, [dispatch, error, isError]);

    return {
        invoices,
        totalDocuments,
        isLoading,
    };
};
